import { useCallback, useEffect, useRef, useState } from 'react'

import { API } from '@/api'
import { getStorageBillingMode, StorageBillingMode } from '@/utils/storage-billing'

interface UseStorageBillingModeResult extends StorageBillingMode {
  loading: boolean
  error: boolean
  refresh: () => Promise<void>
}

export function useStorageBillingMode(): UseStorageBillingModeResult {
  const [state, setState] = useState({
    loading: true,
    error: false,
    imageOnSpaceBilling: true,
    snapshotOnSpaceBilling: true,
  })
  const mountedRef = useRef(true)

  useEffect(() => {
    mountedRef.current = true
    return () => {
      mountedRef.current = false
    }
  }, [])

  const refresh = useCallback(async () => {
    try {
      const res: any = await API.getVolumes()
      if (!mountedRef.current) return
      if (res?.code === 0) {
        setState({
          loading: false,
          error: false,
          ...getStorageBillingMode(res?.volumes),
        })
      } else {
        setState((s) => ({ ...s, loading: false, error: true }))
      }
    } catch (err) {
      console.error('Failed to fetch storage billing mode:', err)
      if (mountedRef.current) {
        setState((s) => ({ ...s, loading: false, error: true }))
      }
    }
  }, [])

  useEffect(() => {
    refresh()
  }, [refresh])

  return { ...state, refresh }
}
